/* js/components/ShareButton.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	space,
	src_url_equal,
	toggle_class
} from "svelte/internal";

import { Config } from '../config';

function create_if_block(ctx) {
	let div;
	let mounted;
	let dispose;

	return {
		c() {
			div = element("div");
			attr(div, "class", "backdrop svelte-1865l0p");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (!mounted) {
				dispose = listen(div, "click", /*click_handler*/ ctx[5]);
				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(div);
			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let t0;
	let div3;
	let div0;
	let t1;
	let div1;
	let a0;
	let img1;
	let img1_src_value;
	let t2;
	let div2;
	let a1;
	let img2;
	let img2_src_value;
	let mounted;
	let dispose;
	let if_block = /*open*/ ctx[0] && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			t0 = space();
			div3 = element("div");
			div0 = element("div");
			div0.innerHTML = `<img src="/_icons/share.svg" class="svelte-1865l0p"/>`;
			t1 = space();
			div1 = element("div");
			a0 = element("a");
			img1 = element("img");
			t2 = space();
			div2 = element("div");
			a1 = element("a");
			img2 = element("img");
			attr(div0, "class", "share-button svelte-1865l0p");
			if (!src_url_equal(img1.src, img1_src_value = "/_icons/facebook.svg")) attr(img1, "src", img1_src_value);
			attr(img1, "class", "svelte-1865l0p");
			attr(a0, "href", /*hrefFB*/ ctx[2]);
			attr(a0, "target", "_blank");
			attr(div1, "class", "share-button svelte-1865l0p");
			if (!src_url_equal(img2.src, img2_src_value = "/_icons/twitter.svg")) attr(img2, "src", img2_src_value);
			attr(img2, "class", "svelte-1865l0p");
			attr(a1, "href", /*hrefTwitter*/ ctx[1]);
			attr(a1, "target", "_blank");
			attr(div2, "class", "share-button svelte-1865l0p");
			attr(div3, "class", "fab-button bottom-right box-shadow share-container svelte-1865l0p");
			toggle_class(div3, "open", /*open*/ ctx[0]);
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, t0, anchor);
			insert(target, div3, anchor);
			append(div3, div0);
			append(div3, t1);
			append(div3, div1);
			append(div1, a0);
			append(a0, img1);
			append(div3, t2);
			append(div3, div2);
			append(div2, a1);
			append(a1, img2);

			if (!mounted) {
				dispose = listen(div3, "click", /*openMenu*/ ctx[3]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (/*open*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(t0.parentNode, t0);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty & /*open*/ 1) {
				toggle_class(div3, "open", /*open*/ ctx[0]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div3);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { url } = $$props;
	let open = false;
	const twitterText = Config.twitter_text;
	const hrefTwitter = encodeURI(`https://twitter.com/intent/tweet/?text=${twitterText}&url=${url}`);
	const hrefFB = encodeURI(`https://facebook.com/sharer/sharer.php?u=${url}`);

	function openMenu() {
		$$invalidate(0, open = !open);
	}

	const click_handler = () => $$invalidate(0, open = false);

	$$self.$$set = $$props => {
		if ('url' in $$props) $$invalidate(4, url = $$props.url);
	};

	return [open, hrefTwitter, hrefFB, openMenu, url, click_handler];
}

class ShareButton extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { url: 4 });
	}
}

export default ShareButton;